// import Container from 'react-bootstrap/Container';
// import { Routes, Route, useNavigate, useLocation,BrowserRouter,Link } from 'react-router-dom';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import Button from 'react-bootstrap/Button';
// import NavDropdown from 'react-bootstrap/NavDropdown';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { Navigate } from 'react-router-dom';
// import './header.css'
// import gradlogo from '../../assets/images/gradlogo.svg';
// import React from 'react';
// import Master from '../../utils/Master';
// import { Modal } from 'react-bootstrap';



// function Header() {

//   const {token,settoken,refreshToken,setrefreshToken}=React.useContext(Master);
//   const [showLogoutConfirm, setShowLogoutConfirm] = React.useState(false);

//   const handleLogout = () => {
//     // Clear auth token / session
//       settoken("");
//       setrefreshToken("");
//     localStorage.clear();
//     setShowLogoutConfirm(false);
//     // Redirect to login
//     // navigate("/login");
//   };

//   return (
//     <>
//         <Navbar className="bg-body-tertiary">

//           <Container fluid>
//             <Navbar.Brand href="new">
//               <img
//                 alt=""
//                 src={gradlogo}
//                 width="120"
//                 height="auto"
//                 className="d-inline-block align-top"
//               />{' '}
//               {/* React Bootstrap */}
//             </Navbar.Brand>
        

//           <Container className="justify-content-end" id="header-nav-links">


//             {/* <Nav.Link className="justify-content-end"> */}

//             <NavDropdown title="Courses"/*  id="basic-nav-dropdown" */ >
//                 <NavDropdown.Item >
//                 <Link
//                   id="coursedetails"
//                   to="/course"
//                   className='navbar-link-item'
//                 >
//                   Course Details
//                 </Link>
//                 </NavDropdown.Item>

//               </NavDropdown>


//               <NavDropdown title="Certificate"/*  id="basic-nav-dropdown" */ >
//                 <NavDropdown.Item >
//                 <Link
//                   id="issued"
//                   to="/issuedcertificates"
//                   className='navbar-link-item'
//                 >
//                   Issued
//                 </Link>
//                 </NavDropdown.Item>
//                 <NavDropdown.Item>
//                 <Link
//                   id="new"
//                   to="/new"
//                   className='navbar-link-item'
//                 >
//                   New
//                 </Link>
//                 </NavDropdown.Item>

//               </NavDropdown>

//               <NavDropdown title="Icons">
//                 <NavDropdown.Item>
//                 <Link
//                   id="icongroups"
//                   to="/icongroups"
//                   className='navbar-link-item'
//                 >
//                   Icon Group
//                 </Link>
//                 </NavDropdown.Item>

//                 <NavDropdown.Item>
//                 <Link
//                   id="addicons"
//                   to="/addicons"
//                   className='navbar-link-item'
//                 >
//                   Add Icon
//                 </Link>
//                 </NavDropdown.Item>
//                 <NavDropdown.Item>
//                 <Link
//                   id="addicongroups"
//                   to="/addicongroups"
//                   className='navbar-link-item'
//                 >
//                   Add Icon Group
//                 </Link>
//                 </NavDropdown.Item>
//               </NavDropdown>

      
            
//           </Container>
//                   {/* Logout Button */}
//                   <Button
//                   variant="danger"
//                   className="logout-btn"
//                   onClick={() => setShowLogoutConfirm(true)}
//                 >
//                   Logout
//                 </Button>
          
//           </Container>
//         </Navbar>
//         <Modal
//         show={showLogoutConfirm}
//         onHide={() => setShowLogoutConfirm(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Logout</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to logout?
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowLogoutConfirm(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={handleLogout}>
//             Logout
//           </Button>
//         </Modal.Footer>
//       </Modal>
//   </>
//   );

// }

// export default Header;












import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Avatar,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Master from "../../utils/Master";
import gradlogo from "../../assets/images/gradlogo.svg";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

function Header() {
  const { token, settoken, refreshToken, setrefreshToken } = useContext(Master);

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userAnchor, setUserAnchor] = useState(null);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [user, setUser] = useState({ name: "Anonymous", role: "" });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const userRole = localStorage.getItem("certificaterole");
  // console.log("Roleeee", userRole);
  

  // Load user info from localStorage
  useEffect(() => {
    const storedUserRole = localStorage.getItem("certificaterole");
    const storedUserName = localStorage.getItem("name");
    if (storedUserRole) {
      try {
        // const parsed = JSON.parse(storedUser);
        setUser({
          name: storedUserName || "Anonymous",
          role: storedUserRole|| "",
        });
      } catch {
        setUser({ name: "Anonymous", role: "" });
      }
    }
  }, []);

  const handleMenuOpen = (event, menu) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menu);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu("");
  };

  const handleUserMenuOpen = (event) => {
    setUserAnchor(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserAnchor(null);
  };

  const handleLogout = () => {
    settoken("");
    setrefreshToken("");
    localStorage.clear();
    setShowLogoutConfirm(false);
    handleUserMenuClose();
  };

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const renderMenuItems = (menu) => {
    switch (menu) {
      case "certificate":
        return (
          <>
            <MenuItem component={Link} to="/issuedcertificates" onClick={handleMenuClose}>
              Issued
            </MenuItem>
            <MenuItem component={Link} to="/new" onClick={handleMenuClose}>
              New
            </MenuItem>
          </>
        );
      case "icons":
        return (
          <>
            <MenuItem component={Link} to="/icongroups" onClick={handleMenuClose}>
              Icon Groups
            </MenuItem>
            <MenuItem component={Link} to="/addicons" onClick={handleMenuClose}>
              Add Icons
            </MenuItem>
            {/* <MenuItem component={Link} to="/addicongroups" onClick={handleMenuClose}>
              Add Icon Group
            </MenuItem> */}
          </>
        );
      default:
        return null;
    }
  };

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer}>
      <List>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/course">
            <ListItemText primary="Course Details" />
          </ListItemButton>
        </ListItem>
        <Divider />
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/issuedcertificates">
            <ListItemText primary="Issued Certificates" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/new">
            <ListItemText primary="New Certificate" />
          </ListItemButton>
        </ListItem>
        <Divider />
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/icongroups">
            <ListItemText primary="Icon Group" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/addicons">
            <ListItemText primary="Add Icon" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/addicongroups">
            <ListItemText primary="Add Icon Group" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar sx={{ justifyContent: "space-between", px: 3 }}>
          {/* Logo */}
          <Box display="flex" alignItems="center" gap={2}>
            <img src={gradlogo} alt="Logo" width="120" height="auto" />
          </Box>

          {/* Nav Links */}
          {!isMobile && (
            <Box display="flex" alignItems="center" gap={3}>
              <Button
                component={Link}
                to="/course"
                sx={{ textTransform: "none", fontWeight: 500, color: "#333", fontSize: "1rem" }}
              >
                Course
              </Button>

              <Button
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => handleMenuOpen(e, "certificate")}
                sx={{ textTransform: "none", fontWeight: 500, color: "#333", fontSize: "1rem" }}
              >
                Certificate
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={activeMenu === "certificate"}
                onClose={handleMenuClose}
                PaperProps={{
                  sx: { borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", width: 180 }
                }}
              >
                {renderMenuItems("certificate")}
              </Menu>

              <Button
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => handleMenuOpen(e, "icons")}
                sx={{ textTransform: "none", fontWeight: 500, color: "#333", fontSize: "1rem" }}
              >
                Icons
              </Button>
                
                {userRole === "certificateadmin" && (
                    <Button
                    component={Link}
                    to="/userManagement"
                    sx={{ textTransform: "none", fontWeight: 500, color: "#333", fontSize: "1rem" }}
                    disabled = {(userRole != "certificateadmin")}
                  >
                    Users
                  </Button>
                )}

            
              
              <Menu
                anchorEl={anchorEl}
                open={activeMenu === "icons"}
                onClose={handleMenuClose}
                PaperProps={{
                  sx: { borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", width: 180 },
                }}
              >
                {renderMenuItems("icons")}
              </Menu>
            </Box>
          )}

          {/* Account Avatar / Mobile */}
          <Box display="flex" alignItems="center" gap={2}>
            {isMobile && (
              <IconButton onClick={toggleDrawer}>
                <MenuIcon />
              </IconButton>
            )}
            <Tooltip title={`${user.name} (${user.role || "Anonymous"})`}>
              <IconButton onClick={handleUserMenuOpen}>
                <Avatar sx={{ bgcolor: "#1976d2", height: 35, width: 35 }}>
                  {user.name.charAt(0).toUpperCase()}
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={userAnchor}
              open={Boolean(userAnchor)}
              onClose={handleUserMenuClose}
              PaperProps={{
                sx: { borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", width: 200},
              }}
            >
              <Box px={2} py={1}>
                <Typography variant="subtitle1">{user.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {user.role || "Anonymous"}
                </Typography>
              </Box>
              <Divider />
              <MenuItem onClick={() => setShowLogoutConfirm(true)}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="left" open={mobileOpen} onClose={toggleDrawer}>
        {drawer}
      </Drawer>

      {/* Logout Confirmation */}
      <Dialog open={showLogoutConfirm} onClose={() => setShowLogoutConfirm(false)}
        maxWidth="sm"   // options: 'xs', 'sm', 'md', 'lg', 'xl', false
        fullWidth       // makes it take the full width up to maxWidth
        sx={{
          '& .MuiDialog-paper': {
            width: '500px',  // you can set custom width here
            maxWidth: '80%', // responsive max width
          },
        }}
        >
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>Are you sure you want to logout?</DialogContent>
        <DialogActions>
          <Button onClick={() => setShowLogoutConfirm(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleLogout} color="error" variant="contained">
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Header;
